document.addEventListener("DOMContentLoaded", () => {
	// Short delay to ensure elements are loaded
	setTimeout(() => {
		initializeCorrectPrice();
		initSubscriptionMonitor();
		setupVariantChangeHandler();
	}, 1000);
});

// Initialize the correct price on page load
function initializeCorrectPrice() {
	const addToCartButton = document.querySelector(
		".product-form__buttons > button"
	);

	if (addToCartButton) {
		// Get price from selected variant JSON data
		const selectedVariantData = getSelectedVariantData();
		if (selectedVariantData && selectedVariantData.price) {
			const priceAmount = selectedVariantData.price / 100;
			const currencySymbol = getCurrencySymbol();
			const formattedPrice = currencySymbol + priceAmount.toFixed(2);
			addToCartButton.setAttribute("data-onetime-price", formattedPrice);

			// Also update the display price in the button
			const priceElement = addToCartButton.querySelector(
				".product-form__submit--current-price"
			);
			if (priceElement) {
				priceElement.textContent = formattedPrice;
			}
		}
	}
}

// Handle variant changes to keep Stay AI in sync
function setupVariantChangeHandler() {
	subscribe(PUB_SUB_EVENTS.variantChange, event => {
		const variant = event.data.variant;
		if (!variant) return;

		// Update the data-onetime-price attribute with current variant price using selected variant data
		const addToCartButton = document.querySelector(
			".product-form__buttons > button"
		);
		if (addToCartButton) {
			// Get price from selected variant JSON data (more reliable)
			const selectedVariantData = getSelectedVariantData();
			if (selectedVariantData && selectedVariantData.price) {
				const priceAmount = selectedVariantData.price / 100;
				const currencySymbol = getCurrencySymbol();
				const formattedPrice = currencySymbol + priceAmount.toFixed(2);
				addToCartButton.setAttribute("data-onetime-price", formattedPrice);
			}
		}

		// Update Stay AI serving prices
		updateStayAIServingPrices(variant);

		// Re-check which option is active and update accordingly
		setTimeout(() => {
			const subscriptionContainer = document.querySelector(
				".rtx_option.rtx_option--sub"
			);
			const onetimeContainer = document.querySelector(
				".rtx_option.rtx_option--onetime"
			);

			if (subscriptionContainer && onetimeContainer && addToCartButton) {
				checkPurchaseOptions(
					subscriptionContainer,
					onetimeContainer,
					addToCartButton
				);
			}
		}, 50);
	});
}

function initSubscriptionMonitor() {
	const subscriptionContainer = document.querySelector(
		".rtx_option.rtx_option--sub"
	);
	const onetimeContainer = document.querySelector(
		".rtx_option.rtx_option--onetime"
	);
	const addToCartButton = document.querySelector(
		".product-form__buttons > button"
	);

	if (!subscriptionContainer || !onetimeContainer || !addToCartButton) {
		console.warn(
			"Subscription container, one-time purchase container, or Add to Cart button not found. Retrying in 1 second..."
		);
		setTimeout(initSubscriptionMonitor, 1000);
		return;
	}

	// Initial check for which purchase option is selected
	checkPurchaseOptions(
		subscriptionContainer,
		onetimeContainer,
		addToCartButton
	);

	// Mutation observers to watch for class changes on both containers
	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			if (
				mutation.type === "attributes" &&
				mutation.attributeName === "class"
			) {
				checkPurchaseOptions(
					subscriptionContainer,
					onetimeContainer,
					addToCartButton
				);
			}
		});
	});

	// Start the observers for both containers
	observer.observe(subscriptionContainer, {
		attributes: true,
		attributeFilter: ["class"],
	});

	observer.observe(onetimeContainer, {
		attributes: true,
		attributeFilter: ["class"],
	});

	// Also watch for clicks on both options as a fallback
	subscriptionContainer.addEventListener("click", () => {
		// Add a small delay to ensure class changes have been applied
		setTimeout(() => {
			checkPurchaseOptions(
				subscriptionContainer,
				onetimeContainer,
				addToCartButton
			);
		}, 100);
	});

	onetimeContainer.addEventListener("click", () => {
		// Small delay to check if class changes have been applied
		setTimeout(() => {
			checkPurchaseOptions(
				subscriptionContainer,
				onetimeContainer,
				addToCartButton
			);
		}, 100);
	});
}

function checkPurchaseOptions(
	subscriptionContainer,
	onetimeContainer,
	addToCartButton
) {
	// Check which option is active
	const isSubscriptionActive =
		subscriptionContainer.classList.contains("option--active");
	const isOnetimeActive =
		onetimeContainer.classList.contains("option--active");

	// Check which option is active
	if (isSubscriptionActive) {
		// Get the subscription details and price
		const subheadingElement = subscriptionContainer.querySelector(
			".rtx_option_subheading"
		);
		const subscriptionText = subheadingElement
			? subheadingElement.textContent.trim()
			: "";

		let subscriptionPrice = extractPriceFromText(subscriptionText);

		// Update the add to cart button
		updateAddToCartButton(
			addToCartButton,
			true,
			subscriptionText,
			subscriptionPrice
		);
	} else if (isOnetimeActive) {
		// Get the one-time purchase price from the selected variant JSON data
		let onetimePrice = "";
		const stayAiOneTimePriceEl = onetimeContainer.querySelector(
			".rtx_option_subheading"
		);

		// Get price from selected variant JSON data (more reliable than data-onetime-price)
		const selectedVariantData = getSelectedVariantData();
		if (selectedVariantData && selectedVariantData.price) {
			// Convert price from cents to currency units and format
			const priceAmount = selectedVariantData.price / 100;
			const currencySymbol = getCurrencySymbol();
			onetimePrice = currencySymbol + priceAmount.toFixed(2);

			if (stayAiOneTimePriceEl) {
				stayAiOneTimePriceEl.textContent = onetimePrice;
			}

			// Update the data-onetime-price attribute for consistency
			addToCartButton.setAttribute("data-onetime-price", onetimePrice);
		}

		// Update the add to cart button (but don't change the price since it's already correct)
		updateAddToCartButton(addToCartButton, false, "", onetimePrice);
	}
}

// Helper function to get currency symbol from button data attribute
function getCurrencySymbol() {
	const addToCartButton = document.querySelector(
		".product-form__buttons > button"
	);
	// Get currency symbol from data attribute, fallback to "$" if not found
	return addToCartButton?.getAttribute("data-store-currency") || "$";
}

// Helper function to extract price from text
function extractPriceFromText(text) {
	if (!text) return "";

	// Look for a price pattern ($XX.XX or $XX) - using dynamic currency symbol
	const currencySymbol = getCurrencySymbol();
	const escapedSymbol = currencySymbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	const priceMatch = text.match(
		new RegExp(`\\${escapedSymbol}\\d+(\\.\\d{2})?`)
	);
	return priceMatch ? priceMatch[0] : "";
}

// Helper function to get selected variant data from JSON script tag
function getSelectedVariantData() {
	try {
		const selectedVariantScript = document.querySelector(
			"script[data-selected-variant]"
		);
		if (selectedVariantScript) {
			const variantData = JSON.parse(selectedVariantScript.textContent);
			return variantData;
		}
	} catch (error) {
		console.warn("Could not parse selected variant data:", error);
	}
	return null;
}

function updateAddToCartButton(
	button,
	isSubscription,
	subscriptionText,
	price
) {
	// Set subscription data attributes
	button.dataset.subscriptionSelected = isSubscription ? "true" : "false";
	button.dataset.subscriptionDetails = subscriptionText || "";

	// Update the price in the button
	const priceElement = button.querySelector(
		".product-form__submit--current-price"
	);

	if (priceElement && price) {
		// Store the original price if this is the first time we're updating it
		if (!button.dataset.originalPrice) {
			button.dataset.originalPrice = priceElement.textContent;
		}

		// Update the price for both subscription and one-time purchase
		priceElement.textContent = price;
	} else if (priceElement && !price && button.dataset.originalPrice) {
		// Reset to original price if no new price
		priceElement.textContent = button.dataset.originalPrice;
	}

	// Custom event that other parts of your code can listen for
	const event = new CustomEvent("subscriptionStatusChanged", {
		detail: {
			isSubscription,
			subscriptionText,
			price,
		},
	});
	document.dispatchEvent(event);
}

// Update Stay AI serving prices when variant changes
function updateStayAIServingPrices(variant) {
	try {
		// Get product data for serving calculations
		const productJsonScript = document.querySelector('[id*="ProductJson-"]');
		if (!productJsonScript) return;

		const productData = JSON.parse(productJsonScript.textContent);
		const variantData = productData.metafields.find(
			v => v.vid === variant.id
		);

		if (!variantData) return;

		// Calculate serving prices
		const servings = variantData.servings || 28;
		const servingPrice = variant.price / servings;

		// Update one-time serving price elements
		const onetimeServingPriceElements = document.querySelectorAll(
			"[data-serving-price]:not([data-sub-discount])"
		);
		const currencySymbol = getCurrencySymbol();
		onetimeServingPriceElements.forEach(element => {
			const formattedPrice =
				currencySymbol + (servingPrice / 100).toFixed(2);
			element.textContent = formattedPrice;
		});

		// Update subscription serving prices if available
		if (
			variant.selling_plan_allocations &&
			variant.selling_plan_allocations.length > 0
		) {
			const subscriptionPrice = variant.selling_plan_allocations[0].price;
			const subscriptionServingPrice = subscriptionPrice / servings;

			const subscriptionServingPriceElements = document.querySelectorAll(
				"[data-serving-price][data-sub-discount]"
			);
			subscriptionServingPriceElements.forEach(element => {
				const formattedPrice =
					currencySymbol + (subscriptionServingPrice / 100).toFixed(2);
				element.textContent = formattedPrice;
			});
		}
	} catch (error) {
		console.warn("Could not update Stay AI serving prices:", error);
	}
}
